// import React from 'react';
// import zoom from '../img/zoom.png';
// import airtable from '../img/airtable.png';
// import youtube from '../img/youtube.png';

let Timeline = [{
    date: "January 20th - January 29th, 8am - 4pm PST | Sproul/Glade",
    title: "Tabling",
    description: "Drop by Sproul and Memorial Glade to learn more about our people, projects, and impact! Take this time to meet our incredible members and to ask any questions about consulting for Net Impact.",
    link: "https://airtable.com/appzavtFjBRUlUmPt/pagqItCKlhH3VB25J/form",
    linkText: "Interest Form",
},
{
    date: "January 20th - January 29th, 8am - 6pm PST | Zoom/In Person",
    title: "Coffee Chats",
    description: "Sign up for a 20 minute chat with one of our members anytime to meet someone from our community.",
    link: "https://nib.berkeley.edu/members",
    linkText: "Meet our Members",
},
{
    date: "Tuesday, January 27th, 8-10 PM PST | VLSB 2040",
    title: "Info Session #1",
    description: "Join us at one of our info sessions to get a glimpse into what it means to be part of Net Impact Berkeley and to see what we offer to all majors, backgrounds, and interests. You'll have the opportunity to learn more about our upcoming projects, socials, trainings and external events and to connect with all of our members.",
},
{
    date: "Wednesday, January 28th, 8-10 PM PST | VLSB 2040",
    title: "Info Session #2 + Case Workshop",
    description: "We will hold an open networking session from 8-9pm outside of VLSB to provide an opportunity to meet our members and learn about their past experiences as members of NIB. From 9-10pm we host a case workshop to help walk you through the case portion of our interview and what to expect from the overall interview process. This includes best practices, a sample case, and time to ask questions.",
},
{
    date: "Thursday, January 29th, 8-10 PM PST | VLSB 2040",
    title: "Case Coaching Session",
    description: "Come learn about Net Impact's interview process and how to crush a case interview at our Case Coaching Session. You'll have the chance to work in small groups to solve a real world case and learn how to approach and solve case interview questions.",
},
{
    date: "Friday, January 30th, 1 PM PST",
    title: "Applications Due",
    description: "Our application consists of a resume drop and a few short answer questions. Please submit your application by 1 PM on Friday if you'd like to apply!",
    // link: "https://airtable.com/app5kIIT8OgWGBQWj/pagO6AnGJoBTImhIN/form",
    //linkText: "Application"
},
{
    date: "Saturday, January 31st",
    title: "First Round Interviews",
    description: "Invite Only",
},
{
    date: "Sunday, February 1st",
    title: "Meet Net Impact Berkeley",
    description: "Invite Only",
},
{
    date: "Monday, February 2nd",
    title: "Coffee Chats",
    description: "Invite Only",
},
{
    date: "Tuesday, February 3rd",
    title: "Second Round Interviews",
    description: "Invite Only",
},
{
    date: "Thursday, February 5th",
    title: "Welcome to Net Impact Berkeley",
    description: "Invite Only",
}


];

export default Timeline;